import {useState} from 'react'
import Date from '../../../../components/Date/Date'
import ProductReturnDetailsModal from '../../sections/modals/ProductReturnDetailsModal'
import RtvDetailsModal from '../../sections/modals/RtvDetailsModal'
import OutOfStockOccurrenceDetailsModal from '../../sections/modals/OutOfStockOccurrenceDetailsModal'

const ReplenishmentReportTableRow = ({row: item}: any) => {
  const [showProductReturnDetailsModal, setShowProductReturnDetailsModal] = useState(false)
  const [showRtvDetailsModal, setShowRtvDetailsModal] = useState(false)
  const [showOutOfStockOccurrenceModal, setShowOutOfStockOccurrenceModal] = useState(false)

  return (
    <>
      <tr className={`${item?.isParent ? 'fw-bold  bg-light' : ''}`}>
        <td>{item?.isParent ? item?.parentSku : item?.variantSku}</td>
        <td>{item?.productTitle}</td>
        <td>{item?.quantityAvailable}</td>
        <td>{item?.reservedQuantity}</td>
        <td>{item?.quantityIncoming}</td>
        <td>{item?.month_7}</td>
        <td>{item?.month_6}</td>
        <td>{item?.month_5}</td>
        <td>{item?.month_4}</td>
        <td>{item?.month_3}</td>
        <td>{item?.month_2}</td>
        <td>{item?.month_1}</td>
        <td>
          <Date date={item?.lastReceivedDate} />
        </td>
        <td>{item?.lastReceivedQuantity}</td>
        <td>
          <Date date={item?.lastOutOfStockDate} />
        </td>
        <td>
          {item?.occurrenceRange ? (
            <span
              className='text-decoration-underline cursor-pointer'
              onClick={() => setShowOutOfStockOccurrenceModal(true)}
            >
              {item?.occurrenceRange}
            </span>
          ) : (
            '-'
          )}
        </td>
        <td>
          {item?.rtv ? (
            <span
              className={'text-decoration-underline cursor-pointer'}
              onClick={() => setShowRtvDetailsModal(true)}
            >
              {item?.rtv}
            </span>
          ) : (
            '-'
          )}
        </td>
        <td>
          {item?.totalZeroQuantity ? (
            <span
              className='text-decoration-underline cursor-pointer'
              onClick={() => setShowProductReturnDetailsModal(true)}
            >
              {item?.totalZeroQuantity}
            </span>
          ) : (
            '-'
          )}
        </td>
      </tr>
      {showProductReturnDetailsModal && (
        <ProductReturnDetailsModal
          show={showProductReturnDetailsModal}
          onClose={() => setShowProductReturnDetailsModal(false)}
          variantSku={item['variantSku']}
          parentSku={item['parentSku']}
          isParent={item?.isParent}
          title={item['productTitle']}
        />
      )}
      {showRtvDetailsModal && (
        <RtvDetailsModal
          show={showRtvDetailsModal}
          onClose={() => setShowRtvDetailsModal(false)}
          variantSku={item['variantSku']}
          parentSku={item['parentSku']}
          title={item?.isParent ? item['productTitle'] : item['variantSku']}
          dialogClassName='modal-xl'
          isChild={!item?.isParent}
        />
      )}
      {showOutOfStockOccurrenceModal && (
        <OutOfStockOccurrenceDetailsModal
          onClose={() => setShowOutOfStockOccurrenceModal(false)}
          row={item}
          isParentRow={item?.isParent}
        />
      )}
    </>
  )
}

export default ReplenishmentReportTableRow
